<div class="p-0">
  <form *ngIf="form" [formGroup]="form" class="mb-10 row">
    <div class="col-10">
      <mat-form-field appearance="outline" class="mb-5">
        <mat-label>Item</mat-label>
        <input matInput formControlName="description" required />
      </mat-form-field>
    </div>
    <div class="col-2">
      <div class="d-flex align-items-end justify-content-between mt-2">
        <div class="d-flex align-items-center">
          <button
            mat-raised-button
            class="btn btn-primary"
            [disabled]="mode === 'view'"
            (click)="addItem($event)"
          >
            {{ index ? 'Update' : 'Add' }} Checklist Item
          </button>
          <button
            *ngIf="index"
            mat-raised-button
            class="btn btn-light ml-4"
            (click)="cancelItemUpdate($event)"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </form>
  <div class="border rounded p-4">
    <div *ngIf="!checklist?.length" class="font-weight-bold text-center w-100">
      There are no items added!
    </div>
    <ng-container *ngIf="checklist?.length">
      <div class="row bg-light border rounded font-weight-bold m-0 mb-4 p-2 w-100">
        <div class="col-10">Item</div>
        <div class="col-2">Actions</div>
      </div>
      <mat-spinner [diameter]="20" *ngIf="!loaded"></mat-spinner>
      <div style="overflow-y: scroll; max-height: 200px" *ngIf="loaded">
        <div
          *ngFor="let item of checklist; let i = index"
          class="row border-bottom m-0 mb-2 p-2 w-100"
        >
          <div class="col-10">{{ item.description }}</div>
          <div class="col-2" *ngIf="mode !== 'view'">
            <button
              class="btn btn-icon btn-sm btn-light btn-hover-primary mr-1"
              [matTooltip]="'TABLE.UPDATE' | translate"
              (click)="updateItem($event, i)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                class="svg-icon svg-icon-md svg-icon-primary"
              ></span>
            </button>
            <button
              class="btn btn-icon btn-sm btn-light btn-hover-danger"
              [matTooltip]="'TABLE.DELETE' | translate"
              (click)="deleteItem($event, i)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                class="svg-icon svg-icon-md svg-icon-danger"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
